import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isProfileComplete } from '../utils/profileCompletion';

function ProfileCompletionGuard({ children, user, authChecking }) {
  const location = useLocation();
  
  // Check if user is admin/courier (skip profile check for them)
  const userRole = user?.role?.name;
  const isAdmin = userRole === 'super_admin' || userRole === 'administrator' || userRole === 'manager';
  const isCourier = userRole === 'courier';

  // Check if profile is complete
  const profileComplete = user ? isProfileComplete(user) : true;
  
  // Debug logging - must be called before any early returns
  useEffect(() => {
    if (!authChecking && user && !isAdmin && !isCourier) {
      console.log('ProfileCompletionGuard check:', {
        user: user?.email,
        profileComplete,
        location: location.pathname,
        missingFields: !profileComplete ? Object.keys(user).filter(key => {
          const requiredFields = ['name', 'email', 'phone'];
          return requiredFields.includes(key) && !user[key];
        }) : []
      });
    }
  }, [user, authChecking, profileComplete, location.pathname, isAdmin, isCourier]);
  
  // Show loading state while checking authentication
  if (authChecking) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If no user, allow access (they'll be handled by auth flow)
  if (!user) {
    return children;
  }

  // Skip profile check for admins/couriers
  if (isAdmin || isCourier) {
    return children;
  }
  
  if (!profileComplete) {
    // Redirect to profile page to complete registration
    console.log('Redirecting to /profile - profile incomplete');
    return <Navigate to="/profile" replace />;
  }

  return children;
}

export default ProfileCompletionGuard;
